export const azureDiskPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/disks`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/disks`,
  detail: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/disks/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}`,
};
